import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ContainerSubLogin = styled(Box)`
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 28vw;
  margin-bottom: 20px;

  @media (max-width: 540px) {
    width: fit-content;
  }

  .register {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 0.4rem;
    cursor: pointer;
    color: ${({ theme }) => theme.palette.primary.main};

    .register-text {
      margin-left: 4px;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-decoration-line: underline;
      color: rgba(0, 0, 0, 0.87);
      text-transform: none;
    }
  }
`;
